<template>
  <div class="pa-5 pt-2">
    <v-row>
      <v-col cols="12">
        <cogs-estimate-data-table :refresh="isRefresh" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CogsEstimateDataTable from './DataTable'
export default {
  name: 'cogs-estimate',
  components: {
    CogsEstimateDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
    reload() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?1b1cfb22